import { Chip } from "@mui/material";
import { Localized, useLocalization } from "@fluent/react";
import { UrsOfferStatus } from "./ursOfferSlice";

export const UrsOfferStatusChip = ({ status }: { status: UrsOfferStatus | undefined }) => {
    const { l10n } = useLocalization()

    if (!status) return null;


    const statusMap: Record<UrsOfferStatus, { color: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning"; labelId: string; defaultLabel: string }> = {
        N: { color: "info", labelId: "urs-offer-status-n", defaultLabel: "Komentowanie" },
        R: { color: "error", labelId: "urs-offer-status-r", defaultLabel: "Odrzucone" },
        S: { color: "success", labelId: "urs-offer-status-s", defaultLabel: "Wybrano" },
        A: { color: "primary", labelId: "urs-offer-status-a", defaultLabel: "Złożono ofertę" },
        E: { color: "warning", labelId: "urs-offer-status-e", defaultLabel: "W ocenie" },
        F: { color: "info", labelId: "urs-offer-status-f", defaultLabel: "Zakończono" },
        O: { color: "default", labelId: "urs-offer-status-o", defaultLabel: "Zakończono" },
        D: { color: "secondary", labelId: "urs-offer-status-d", defaultLabel: "Discussion" },
        C: { color: "default", labelId: "urs-offer-status-c", defaultLabel: "Anulowano" },
        OPINION_COMPLETED: { color: "default", labelId: "urs-offer-status-opinion-completed", defaultLabel: "Opinia zakończona" }
    };

    const mapped = statusMap[status];

    const statusText = l10n.getString("urs-offer-status-" + status.toLowerCase(), null, "_Status");
    if (status === 'OPINION_COMPLETED') {
        var sztatusText = l10n.getString("urs-offer-status-opinion-completed", null, "_Status");
        return <Chip label={sztatusText} color="default" size="small" />;
    }
    if (!mapped) return <Chip label={status} variant="outlined" />;

    return (
        <Chip label={statusText} color={mapped.color} size="small" />
    );
};
